import Vue from 'vue';

import App from './App.vue';
import { menuRouter } from '../../src/';

Vue.use(menuRouter);

const app = new Vue(App);

app.$mount('#app');
